import { render, staticRenderFns } from "./App.vue?vue&type=template&id=be1861aa&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=be1861aa&prod&lang=less"
import style1 from "./App.vue?vue&type=style&index=1&id=be1861aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1861aa",
  null
  
)

export default component.exports